<template>
    <b-container fluid>
        <b-row class="progress-tabs">
            <b-col v-for="(step, index) in steps" v-bind:key="index" :style="{'z-index': steps.length-index}" :class="getClass(index)" class="progress-tab" :id="'tab-'+index" role="progressbar" :aria-valuenow="percentage(index)" aria-valuemin="0" aria-valuemax="100">
                <div @click="$emit('selected', index)" class="row flex-nowrap">
                    <span class="col">{{step.title}}</span><i v-show="index<current" class="float-right fas fa-check col-auto px-0 mt-1"></i>
                </div>
            </b-col>
            
            <div class="progress-steps progress-tab col-auto">
                <div class="row flex-nowrap">
                    <span class="col">{{current+1}}/{{steps.length}}</span>
                </div>
            </div>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: 'ProgressTab',
        props: {
            current: Number,
            steps: Array
        },
        methods: {
            getClass: function (step) {
                return step<this.current ? "progress-finished" : (step==this.current ? "progress-active" : "progress-upcoming")
            },

            percentage: function (step) {
                return step*100/this.steps.length;
            }
        }
    }
</script>

<style lang="scss">
    .progress-tabs {
        font-family: Roboto Bold;
        font-size: 18px;
        padding: 0 0 0 5px;
        margin: 0;
        display: flex;
    }

    .progress-tab {
        justify-content: center;
        display: flex;
        text-align: center;
        flex-direction: column;
        white-space: nowrap;
        height: 40px;
        padding: 0 26px;
        border: 1px solid #ffffff;
        border-radius: 7px;
        margin-left: -5px;
    }

    .progress-finished {
        cursor: pointer;
        display: none;
    }

    .progress-upcoming {
        display: none;
    }

    // MD Medium devices (tablets, 768px and up)
    @media (min-width: 768px) {
        .progress-steps {
            display: none;
        }
        
        .progress-finished {
            display: flex;
        }

        .progress-upcoming {
            display: flex;
        }
    }

</style>
